import React, { useState, useCallback, useEffect } from "react";
import Cropper from "react-easy-crop";
import { Dialog } from "@mui/material";
import getCroppedImg from "../helpers/cropImage";
import { Model } from "./Model";
import { Button } from "react-bootstrap";
import { useApi } from "../helpers/useApi";
import { API_URL_ENDPOINT } from "../appsetting";
import { sendError } from "../helpers/Helper";

export default function SignatureUploader({imageURL, onUploaded}) {
  const callApi = useApi();
  const [imageSrc, setImageSrc] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [cropDialogOpen, setCropDialogOpen] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  useEffect(()=>{
    setCroppedImage(imageURL)
  },[imageURL])

  const showFilePicker = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = async (e) => {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImageSrc(reader.result);
        setCropDialogOpen(true);
      };
    };
    input.click();
  };



  const saveCroppedImage = async () => {
    const cropped = await getCroppedImg(imageSrc, croppedAreaPixels);
    setCroppedImage(cropped);
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("file", cropped); // append the actual file
      formData.append("type", "companySignatures"); // add type field

      const response = await callApi(API_URL_ENDPOINT.Document + "/upload", {
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status) {
        // sendSuccess(response.message);
        const documentKey = response.data?.fileKey || null;
        onUploaded(documentKey);
      } else {
        throw new Error(response.message || "Something went wrong");
      }
    } catch (ex) {
      sendError(ex.message);
      return null;
    } finally {
      setCropDialogOpen(false);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="text-end">
      <div>
        <p className="mb-1">Bilty Signature</p>
        <div
          className="border float-end"
          style={{
            width: 250,
            height: 60,
            cursor: "pointer",
            backgroundImage: `url(${croppedImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          onClick={showFilePicker}
        ></div>
      </div>

      <Model show={cropDialogOpen}>
        <div style={{ position: "relative", height: 300 }}>
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={250 / 60} // aspect ratio for signature area
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        </div>
        <div className="text-end pt-2">
          <Button
            disabled={isSubmitting}
            type="Button"
            className="me-2"
            variant="outline-danger"
            onClick={() => setCropDialogOpen(false)}
          >
            Close
          </Button>
          <Button
            disabled={isSubmitting}
            onClick={saveCroppedImage}
            className=""
            variant="success"
          >
            Upload Signature
          </Button>
        </div>
      </Model>
    </div>
  );
}
